module.exports = __webpack_public_path__ + "img/WRZS_scenario.68ba0201.png";